import React, {
  useState,
  useRef,
  useEffect,
  useContext,
  useCallback,
} from "react";
import { Dropdown } from "../../../../shadcn/components/custom/Dropdown";
import { useRouter } from "next/router";
import { Input } from "../../../../shadcn/components/ui/input";
import { Switch } from "../../../../shadcn/components/ui/switch";
import VerifiedHammer from "../../../../icons/VerifiedHammer";
import ChevronUpSvg from "../../../../icons/ChevronUpSvg";
import ChevronDownSvg from "../../../../icons/ChevronDownSvg";
import PriceRangeSelector from "../../propertyList/PriceRangeSelector";

import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "../../../../shadcn/components/ui/popover";

import { Checkbox } from "../../../../shadcn/components/ui/checkbox";
import {
  Context,
  getPrivatePropertySearchResults,
  getSearchResults,
  payloadToUrl,
} from "services";
import Dot from "../../../../icons/Dot";
import { Button } from "../../../../shadcn/components/ui/button";
interface FilterSectionWebProps {
  handleClearFilters: any;
}

export default function FilterSectionWeb({
  handleClearFilters,
}: FilterSectionWebProps) {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);

  const [assetTypeOptions, setAssetTypeOptions] = useState<any[]>([]);

  const filterData = (dataToFilter: any) => {
    return (dataToFilter || []).map((data: any) => ({
      label: data.parent.asset_type_name,
      value: data.parent.asset_type_slug,
    }));
  };

  const getFilterForSubAssetType = (searchForm: any) => {
    const filters = [];
    if (searchForm.value.asset_type.value) {
      const currentFilterString = `dump.asset.asset_type_slug:=${searchForm.value.asset_type.value}`;
      filters.push(currentFilterString);
    }
    return filters;
  };

  const fetchOptions = async (): Promise<any[]> => {
    const initialData: any = await getPrivatePropertySearchResults({
      searches: [
        {
          query_by: "",
          collection: "posted-properties",
          q: "*",
          facet_by: "dump.asset.asset_type_name,dump.asset.asset_type_slug,",
          facet_return_parent:
            "dump.asset.asset_type_name,dump.asset.asset_type_slug,",
          filter: "true",
          max_facet_values: "500",
          infix: "always",
        },
        {
          query_by: "",
          collection: "posted-properties",
          q: "*",
          facet_by:
            "dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug",
          facet_return_parent:
            "dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug",
          filter: "true",
          filter_by: getFilterForSubAssetType(searchForm).join(" && "),
          max_facet_values: "500",
          infix: "always",
        },
      ],
    });

    return (
      initialData?.results?.map((result: any) => ({
        group: "popular",
        data: filterData(result.facet_counts?.[0]?.counts),
      })) || []
    );
  };

  useEffect(() => {
    const initializeOptions = async () => {
      const data = await fetchOptions();
      setAssetTypeOptions(data[0]?.data || []);
    };
    initializeOptions();
  }, [searchForm.value.asset_type]);

  const scheduleData = [
    { label: "Auction Properties ", value: "dated" },
    { label: "Private Properties ", value: "undated" },
  ];

  const handleSelectedScheduleOption = (value: any) => {
    if (value?.value === "dated") {
      window.location.href =
        searchForm.value.city.value === ""
          ? `/auction-properties`
          : `/auction-properties-in-${searchForm.value.city.value}`;
    } else {
      window.location.href = `/private-properties?city=${searchForm.value.city.value}`;
    }
  };

  // const privateSaleData = [
  //   { label: "Private Treaty (By Banker)", value: "private_treaty" },
  //   { label: "Private Property (By Individual)", value: "private_property" },
  // ];
  const handlesPrivateSaleOption = (value: any) => {
    searchForm.setField("filter_by", value);
  };

  const [showRightArrow, setShowRightArrow] = useState(false);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScrollCheck = () => {
      const container = scrollContainerRef.current;
      if (container) {
        setShowRightArrow(
          container.scrollWidth > container.clientWidth &&
            container.scrollLeft <
              container.scrollWidth - container.clientWidth - 1
        );
        setShowLeftArrow(container.scrollLeft > 0);
      }
    };

    handleScrollCheck();
    window.addEventListener("resize", handleScrollCheck);

    // Listen for scroll changes
    const container = scrollContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScrollCheck);
    }

    return () => {
      window.removeEventListener("resize", handleScrollCheck);
      if (container) {
        container.removeEventListener("scroll", handleScrollCheck);
      }
    };
  }, []);

  const handleScrollToEnd = () => {
    const container = scrollContainerRef.current;
    if (container) {
      container.scrollTo({
        left: container.scrollWidth,
        behavior: "smooth",
      });
    }
  };

  const handleScrollToStart = () => {
    const container = scrollContainerRef.current;
    if (container) {
      container.scrollTo({
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const dataSource: () => Promise<any> = () => {
    return Promise.resolve(assetTypeOptions);
  };

  const handleSetSelectedOption = (item: any) => {
    // setSelectedOption(item);
    searchForm.setField("asset_type", item);
    searchForm.setField("sub_asset_type", "");
  };

  const auctionVerifiedData = [
    { label: "Verified Property", value: "auction_verified" },
  ];

  const handleSwitchChange = (checked: boolean) => {
    const filterField = searchForm.getField("filter_by");
    if (checked) {
      // if (filterField && filterField !== "") {
      searchForm.setField("ab_verified", {
        label: "Verified Property",
        value: "auction_verified",
      });
      // } else {
      //   searchForm.setField("filter_by", {
      //     label: "Verified Property",
      //     value: "auction_verified",
      //   });
      // }
    } else {
      const isFilterVerified =
        filterField &&
        auctionVerifiedData?.some((item) => filterField.value === item.value);

      if (isFilterVerified) {
        searchForm.setField("filter_by", "");
      }
      searchForm.setField("ab_verified", "");
      // } else {
      // }
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    searchForm.setField("listing_id_query", value);
  };

  return (
    <section className="min-h-[143px] w-full bg-white sticky hidden lg:block top-10 z-30 pt-9 py-4 shadow-sm">
      <div className="relative flex px-customPadding w-full 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
        <div className="flex items-center flex-1 overflow-x-auto relative ">
          <div
            ref={scrollContainerRef}
            className="flex gap-x-5 gap-y-2 xl:gap-y-3 items-center flex-wrap "
          >
            <div className="">
              <Input
                type="text"
                placeholder="Search ID"
                value={
                  searchForm.getField("listing_id_query")
                    ? searchForm.getField("listing_id_query") !== ""
                      ? searchForm.getField("listing_id_query")
                      : ""
                    : ""
                }
                onChange={handleInputChange}
                className="max-w-[130px] xl:max-w-[154px] rounded-lg border-brand-borderGrey text-sm focus:border-none focus:border-brand-borderGrey"
              />
            </div>
            <div key={1}>
              <Dropdown
                dataSource={dataSource}
                defaultSelected={
                  searchForm.getField("asset_type") !== ""
                    ? searchForm.getField("asset_type")
                    : undefined
                }
                selectIdentifier={true}
                onChange={(value: any) => handleSetSelectedOption(value)}
                valueKey="value"
                placeholder="Asset type"
                styles={{
                  dropdownItemsClass: "text-brand-borderGrey",
                  hoverBgColor: "focus:bg-brand-lightPink",
                  hoverTextColor: "focus:text-brand-borderGrey",
                  outerContainer:
                    "border-[1px] border-brand-borderGrey hover:border-brand-orange min-w-[130px] xl:min-w-[170px] rounded-lg text-sm leading-normal font-openSans text-brand-textBlack px-4",
                }}
              />
            </div>
            <div key={2}>
              <PropertySubTypeFilter />
            </div>
            <div key={3}>
              <PriceRangeBasicDropDown />
            </div>
            {process.env.NEXT_PUBLIC_PYP_ENABLE === "true" ? (
              <div key={6}>
                <Dropdown
                  dataSource={() => {
                    return Promise.resolve(scheduleData);
                  }}
                  defaultSelected={
                    searchForm.getField("filter_by") !== ""
                      ? scheduleData.find(
                          (item) =>
                            searchForm.getField("filter_by").value ===
                            item.value
                        )
                      : undefined
                  }
                  selectIdentifier={true}
                  onChange={(value: any) => handleSelectedScheduleOption(value)}
                  valueKey="value"
                  placeholder="Private Properties"
                  styles={{
                    dropdownItemsClass: "text-brand-borderGrey",
                    hoverBgColor: "focus:bg-brand-lightPink",
                    hoverTextColor: "focus:text-brand-borderGrey",
                    outerContainer:
                      "border-[1px] border-brand-borderGrey hover:border-brand-orange min-w-[130px] xl:min-w-[154px] rounded-lg text-sm leading-normal font-openSans text-brand-textBlack px-4",
                  }}
                />
              </div>
            ) : (
              <></>
            )}

            <div
              key={9}
              className="flex items-center gap-2 px-3 py-2 bg-[#F8F8F8] rounded-lg drop-shadow-sm"
            >
              <VerifiedHammer />
              <Switch
                checked={
                  searchForm.getField("filter_by") !== ""
                    ? auctionVerifiedData.find(
                        (item) =>
                          searchForm.getField("filter_by").value === item.value
                      )
                      ? true
                      : searchForm.getField("ab_verified") &&
                        searchForm.getField("ab_verified") !== ""
                      ? true
                      : false
                    : searchForm.getField("ab_verified") &&
                      searchForm.getField("ab_verified") !== ""
                    ? true
                    : false
                }
                onCheckedChange={handleSwitchChange}
              />
            </div>
            <div key={4} className="w-[60px]"></div>
            <div key={5}></div>
            {/* Switch and Icon */}
          </div>
        </div>
        <Button
          className="ml-5 px-5 text-xs py-[9px]"
          onClick={() => {
            handleClearFilters();
          }}
        >
          Clear Filter
        </Button>
      </div>
    </section>
  );
}

const PriceRangeBasicDropDown = () => {
  const { searchForm }: any = useContext(Context);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRange, setSelectedRange] = useState<
    [number | null, number | null]
  >([0, null]);

  // Format numbers into Indian currency format
  const formatIndianCurrency = (number: any) => {
    if (number || number === 0) {
      if (number >= 1_00_00_000)
        return `${(number / 1_00_00_000).toFixed(1)}Cr`;
      if (number >= 1_00_000) return `${(number / 1_00_000).toFixed(1)}L`;
      if (number >= 1_000) return `${(number / 1_000).toFixed(1)}K`;
      return number.toString();
    }
    return null;
  };

  // Update the reserve price field when the selected range changes
  useEffect(() => {
    const reservePrice = searchForm.value.reserve_price;
    if (reservePrice) {
      const [minPrice, maxPrice] = reservePrice.split("-").map(Number);
      setSelectedRange([minPrice * 100000, maxPrice * 100000]);
    } else {
      setSelectedRange([0, null]);
    }
  }, [searchForm.value.reserve_price]);

  useEffect(() => {
    const updateReservePrice = () => {
      if ((selectedRange[0] || selectedRange[0] === 0) && selectedRange[1]) {
        const formattedRange = `${Math.floor(
          selectedRange[0] / 100000
        )}-${Math.floor(selectedRange[1] / 100000)}`;
        if (isOpen && selectedRange[0] < selectedRange[1]) {
          searchForm.setField("reserve_price", formattedRange);
        }
      }
    };

    const handler = setTimeout(updateReservePrice, 300);
    return () => clearTimeout(handler);
  }, [selectedRange, isOpen]);

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger asChild>
        <main
          className={`cursor-pointer border-[1px] ${
            isOpen ? "border-brand-orange" : "border-brand-borderGrey"
          } hover:border-brand-orange min-w-[130px] xl:min-w-[154px] rounded-lg pl-4 pr-2 py-[9px]`}
          onClick={() => setIsOpen((prev) => !prev)}
        >
          <div className="flex items-center justify-between">
            {searchForm.getField("reserve_price") &&
            searchForm.getField("reserve_price") !== "" ? (
              <p className="text-[13px] font-openSans text-brand-textBlack flex items-center whitespace-nowrap">
                <span className="mr-3">
                  <Dot />
                </span>
                ₹{formatIndianCurrency(selectedRange[0])} - ₹
                {formatIndianCurrency(selectedRange[1])}
              </p>
            ) : (
              <p className="text-[14px] font-openSans text-brand-textBlack flex items-center whitespace-nowrap">
                Price Range
              </p>
            )}
            <div className="pr-2 pl-2">
              {isOpen ? (
                <ChevronUpSvg width={14} height={14} fill="#7D7D7D" />
              ) : (
                <ChevronDownSvg width={14} height={14} fill="#7D7D7D" />
              )}
            </div>
          </div>
        </main>
      </PopoverTrigger>
      <PopoverContent className="min-w-[439px]">
        <PriceRangeSelector
          range={[0, 2600000000]}
          defaultSelectedRange={selectedRange}
          minStepsBetweenThumbs={500}
          step={500}
          setSelectedRange={setSelectedRange}
        />
      </PopoverContent>
    </Popover>
  );
};

const PropertySubTypeFilter = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { searchForm }: any = useContext(Context);
  const initialCheckedItems = searchForm.value.asset_type
    ? Array.isArray(searchForm.value.sub_asset_type)
      ? searchForm.value.sub_asset_type
      : typeof searchForm.value.sub_asset_type === "object" &&
        searchForm.value.sub_asset_type !== ""
      ? [searchForm.value.sub_asset_type]
      : []
    : [];

  // const [checkedItems, setCheckedItems] = useState<
  //   { label: string; value: string }[]
  // >([]);

  const [assetSubTypeOptions, setAssetSubTypeOptions] = useState<any[]>([]);

  const filterData = (dataToFilter: any) => {
    return (dataToFilter || []).map((data: any) => ({
      label: data.parent.sub_asset_type_name,
      value: data.parent.sub_asset_type_slug,
    }));
  };

  const getFilterForSubAssetType = (searchForm: any) => {
    const filters = [];
    if (searchForm.value.asset_type.value) {
      const currentFilterString = `dump.asset.asset_type_slug:=${searchForm.value.asset_type.value}`;
      filters.push(currentFilterString);
    }
    return filters;
  };
  //checkedItems?.[bank.value]?.booked
  //searchForm.setField("institutes", selected);
  const fetchOptions = async (): Promise<any[]> => {
    const initialData: any = await getSearchResults({
      searches: [
        {
          query_by: "",
          collection: "properties",
          q: "*",
          facet_by:
            "dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug",
          facet_return_parent:
            "dump.asset.sub_asset_type_name,dump.asset.sub_asset_type_slug",
          filter: "true",
          filter_by: getFilterForSubAssetType(searchForm).join(" && "),
          max_facet_values: "500",
          infix: "always",
        },
      ],
    });

    return (
      initialData?.results?.map((result: any) => ({
        group: "popular",
        data: filterData(result.facet_counts?.[0]?.counts),
      })) || []
    );
  };

  useEffect(() => {
    if (searchForm.value.asset_type.value) {
      const initializeOptions = async () => {
        const data = await fetchOptions();
        setAssetSubTypeOptions(data[0]?.data || []);
        // setCheckedItems(initialCheckedItems);
      };
      initializeOptions();
    } else {
      setAssetSubTypeOptions([]);
    }
  }, [searchForm.value.asset_type]);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleCheckboxChange = (
    item: { label: string; value: string },
    isChecked: boolean
  ) => {
    // setCheckedItems((prevCheckedItems) => {
    //   const updatedCheckedItems = isChecked
    //     ? [...prevCheckedItems, item]
    //     : prevCheckedItems.filter(
    //         (checkedItem: { value: string }) => checkedItem.value !== item.value
    //       );
    //   // Update the search form field with the updated list
    //   searchForm.setField("sub_asset_type", updatedCheckedItems);
    //   return updatedCheckedItems;
    // });
    const updatedCheckedItems = isChecked
      ? [...initialCheckedItems, item]
      : initialCheckedItems.filter(
          (checkedItem: { value: string }) => checkedItem.value !== item.value
        );
    searchForm.setField("sub_asset_type", updatedCheckedItems);
  };

  return (
    <Popover onOpenChange={setIsOpen} open={isOpen}>
      <PopoverTrigger asChild>
        <main
          className={`cursor-pointer border-[1px] ${
            isOpen ? "border-brand-orange" : "border-brand-borderGrey"
          } hover:border-brand-orange min-w-[130px] xl:min-w-[160px] rounded-lg pl-4 pr-2 py-[9px]`}
          onClick={toggleDropdown}
        >
          <div className="flex items-center justify-between">
            <div className="text-sm font-openSans text-brand-textBlack capitalize overflow-hidden break-all max-h-5 flex items-center">
              {initialCheckedItems.length > 0 && (
                <span className="mr-3">
                  <Dot />
                </span>
              )}

              <span className="overflow-hidden text-ellipsis whitespace-nowrap capitalize">
                {initialCheckedItems.length > 0 ? (
                  <>
                    {initialCheckedItems[0].label}
                    {initialCheckedItems.length > 1 && (
                      <>,{initialCheckedItems[1].label.slice(0, 3)}...</>
                    )}
                  </>
                ) : (
                  "Sub Asset Type "
                )}
              </span>
            </div>
            <div className="pr-2 pl-2">
              {isOpen ? (
                <ChevronUpSvg width={14} height={14} fill={"#7D7D7D"} />
              ) : (
                <ChevronDownSvg width={14} height={14} fill={"#7D7D7D"} />
              )}
            </div>
          </div>
        </main>
      </PopoverTrigger>
      <PopoverContent className="min-w-[130px] xl:min-w-[160px] max-w-[244px]">
        <div className="max-h-[251px] overflow-scroll w-full">
          {assetSubTypeOptions.map((item, index) => (
            <div key={index} className="flex items-center">
              <Checkbox
                id={`asset-${index}`}
                checkIconClassName="text-brand-bgBlack"
                className="data-[state=checked]:bg-[#EEEEEE] border-brand-bgBlack"
                checked={initialCheckedItems?.some(
                  (checkedItem: any) => checkedItem.value === item.value
                )}
                onCheckedChange={(isChecked: boolean) =>
                  handleCheckboxChange(item, isChecked)
                }
              />
              <label
                htmlFor={`asset-${index}`}
                className="text-sm pl-2 py-1 font-openSans capitalize tracking-wider text-brand-textLightGrey"
              >
                {item.label}
              </label>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
